import { useEffect, useState } from 'react';
import useDocumentTitle from '../../../../hooks/useDocumentTitle';
import { useLoader } from '../../../../context/LoaderContext';
import { UserService } from '../../../../services/UserService';
import { ToasterService } from '../../../../services/ToasterService';
import { useNavigate } from 'react-router-dom';

export default function UseUserAddress() {
  useDocumentTitle('Namasteji Manikchand - Address');
  let parsedUserData: any = {};
  const navigate = useNavigate();
  const getUserLoginData = localStorage.getItem('userLoginData');
  const { setLoading } = useLoader();
  const [shippingAddresses, setShippingAddresses] = useState<any[]>([]);

  useEffect(() => {
    if (getUserLoginData) {
      parsedUserData = JSON.parse(getUserLoginData);
      getAddressList(parsedUserData.customer_id);
    }
  }, []);

  async function getAddressList(customerId: string) {
    try {
      setLoading(true);
      const resp = await UserService.AddressList(customerId);
      setLoading(false);
      if (resp && resp.message && resp.message.addresses && resp.message.addresses.length > 0) {
        const addressDataArr = resp.message.addresses;
        setShippingAddresses(
          addressDataArr.slice().sort((a: any, b: any) => b.is_shipping_address - a.is_shipping_address)
        );
      }
    } catch (err) {
      setLoading(false);
      ToasterService.Error('Server Error!..');
      navigate('/home');
    }
  }

  const states = {
    shippingAddresses,
  };

  return {
    states,
    navigate,
  };
}
